var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeguranca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3950FF23-97C8-48EE-B1CE-6CA222A1AF17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Sidebar-/-Inicio",
    transform: "translate(-25.000000, -326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seguran\\xE7a",
    transform: "translate(25.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password",
    fill: "#B4B4B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75,21 L2.25,21 C1.01,21 0,20.0134222 0,18.8 L0,8.53333333 C0,7.31991111 1.01,6.33333333 2.25,6.33333333 L15.75,6.33333333 C16.99,6.33333333 18,7.31991111 18,8.53333333 L18,18.8 C18,20.0134222 16.99,21 15.75,21 Z M2.25,7.8 C1.837,7.8 1.5,8.12853333 1.5,8.53333333 L1.5,18.8 C1.5,19.2048 1.837,19.5333333 2.25,19.5333333 L15.75,19.5333333 C16.163,19.5333333 16.5,19.2048 16.5,18.8 L16.5,8.53333333 C16.5,8.12853333 16.163,7.8 15.75,7.8 L2.25,7.8 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,7.33333333 C12.2688,7.33333333 12,7.09866667 12,6.80952381 L12,4.19047619 C12,2.45771429 10.3848,1.04761905 8.4,1.04761905 C6.4152,1.04761905 4.8,2.45771429 4.8,4.19047619 L4.8,6.80952381 C4.8,7.09866667 4.5312,7.33333333 4.2,7.33333333 C3.8688,7.33333333 3.6,7.09866667 3.6,6.80952381 L3.6,4.19047619 C3.6,1.87942857 5.7528,0 8.4,0 C11.0472,0 13.2,1.87942857 13.2,4.19047619 L13.2,6.80952381 C13.2,7.09866667 12.9312,7.33333333 12.6,7.33333333 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 0.9,
    cx: 9,
    cy: 14,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguranca);
export default __webpack_public_path__ + "static/media/Seguranca.00fbf534add8286620704ae8a8937dee.svg";
export { ForwardRef as ReactComponent };